module.exports = __webpack_public_path__ + "img/5dbf489.png";